// src/locales/index.ts
// Centrala översättningar för SireusCode
import sv from './sv.json';
import en from './en.json';

export interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

export const translations: Translations = {
  sv: {
    // Navigation
    services: 'Tjänster',
    process: 'Process',
    about: 'Om oss',
    contact: 'Kontakt',
    home: 'Hem',

    // Hero section
    heroTitle: 'Vi löser dina IT-utmaningar, stora som små',
    heroExperience: '+25 års erfarenhet',
    heroRate: 'Alltid 800 kr/timme',
    heroSubtitle: 'Slösa inte mer tid och pengar på ineffektiva IT-lösningar.',
    heroDescription: 'Vi sköter allt från utveckling och underhåll till teknisk rådgivning och IT-stöd, så att du kan fokusera på det som är mest värdefullt för ditt företag.',
    getStarted: 'Kom igång',
    learnMore: 'Läs mer',

    // Process section
    processTitle: 'Så jobbar vi',
    processSubtitle: 'Från strategi till leverans – vi skapar tekniska lösningar som driver din verksamhet framåt.',

    processStep1Title: 'Uppstartsmöte',
    processStep1Desc: 'För att förstå era unika behov lär vi känna er verksamhet på djupet. Utifrån det skapar vi en behovsanalys som ger en klar bild av vilka lösningar som bäst passar er.',

    processStep2Title: 'Planering',
    processStep2Desc: 'Utifrån era mål skapar vi gemensamt en tydlig projektplan som ni enkelt kan följa. Du har full kontroll och godkänner planen innan vi startar arbetet.',

    processStep3Title: 'Utveckling',
    processStep3Desc: 'Arbetet startar enligt planen, och du hålls kontinuerligt uppdaterad. Du får möjlighet att finjustera arbetspaketen för att säkerställa att samtliga resultat lever upp till era mål.',

    processStep4Title: 'Leverans',
    processStep4Desc: 'Varje arbetspaket verifieras tillsammans med er för att se till att alla krav är uppfyllda. Paketen lanseras vid ett tillfälle som passar er, och vi ser till att allt fungerar som det ska.',

    // Process benefits
    processWhyChooseTitle: 'Varför välja vår process?',
    processWhyChooseSubtitle: 'Vår strukturerade approach säkerställer framgång i varje projekt',
    processBenefit1Title: 'Tydlig kommunikation',
    processBenefit1Desc: 'Du är alltid informerad om projektets framsteg',
    processBenefit2Title: 'Flexibel anpassning',
    processBenefit2Desc: 'Vi anpassar oss efter era behov under projektets gång',
    processBenefit3Title: 'Samarbete i fokus',
    processBenefit3Desc: 'Vi arbetar som en förlängning av ert team',

    // Services section
    servicesTitle: 'Oavsett bransch eller utmaning kan vi hjälpa dig att hitta en effektiv digital lösning.',

    service1Title: 'Systemutveckling',
    service1Desc: 'Vi skräddarsyr lösningar för era unika affärsbehov. Från nyutveckling (FoU) och prototypskapande (PoC) till lansering av din första produktversion (MVP), erbjuder vi behovsanalys, kravställning, design, implementation och testning.',

    service2Title: 'Molntjänster',
    service2Desc: 'Optimera er IT-plattform med flexibla och skalbara lösningar från AWS, Azure, Google Cloud och Digital Ocean. Få hög tillgänglighet, robust säkerhet och skalbar hosting. Vi hjälper dig att migrera, konfigurera och optimera.',

    service3Title: 'Systemintegration och tredjepartstjänster',
    service3Desc: 'Vi hjälper dig koppla ihop era interna system och externa tjänster. Våra lösningar möjliggör utbyte av data i realtid, förbättrad interoperabilitet och automatiserade processer.',

    service4Title: 'Strategisk IT-rådgivning',
    service4Desc: 'Optimera er affärsstrategi och era kostnader med vår strategiska vägledning. Få expertråd, utveckla IT-strategier, identifiera IT-behov och hantera risker för maximal säkerhet och minimala driftstörningar.',

    // AI section
    aiTitle: 'Kom igång med AI och effektivisera dina arbetsprocesser',
    aiSubtitle: 'Maximera din produktivitet med AI som automatiserar monotona uppgifter, frigör tid och resurser för det som verkligen räknas – kreativa och strategiska initiativ.',
    aiBenefit1: 'Mer tid för strategiskt arbete',
    aiBenefit2: 'Mindre tid på repetitiva uppgifter',
    aiBenefit3: 'Minska felmarginaler',

    // Testimonials
    testimonialsTitle: 'Så säger våra kunder',

    // Team section
    teamTitle: 'Möt teamet bakom SireusCode',

    // Contact section
    contactTitle: 'Redo att ta nästa steg?',
    contactSubtitle: 'Hör av dig så berättar vi gärna mer om hur vi kan hitta IT-lösningar som driver ditt företag framåt.',
    contactDescription: 'Hos SireusCode är vi experter på att förvandla idéer till verklighet. Fyll i formuläret eller kontakta oss direkt för en kostnadsfri konsultation. Vi ser fram emot att samarbeta med dig!',
    contactInfo: 'Kontaktuppgifter',
    phone: 'Telefon',
    email: 'E-post',

    // Contact form
    contactFormTitle: 'Skicka oss ett meddelande',
    name: 'Namn',
    company: 'Företag',
    message: 'Meddelande',
    preferredContact: 'Föredragen kontaktväg',
    gdprConsent: 'Jag godkänner att mina uppgifter behandlas enligt GDPR',
    sendMessage: 'Skicka meddelande',
    sending: 'Skickar...',

    // Form validation
    nameRequired: 'Namn är obligatoriskt',
    emailRequired: 'E-post är obligatorisk',
    emailInvalid: 'Ogiltig e-postadress',
    messageRequired: 'Meddelande är obligatoriskt',
    gdprRequired: 'Du måste godkänna GDPR-villkoren',

    // Notifications
    contactSuccess: 'Tack! Ditt meddelande har skickats.',
    contactError: 'Ett fel uppstod. Försök igen senare.',
    offlineMessage: 'Du är offline - vissa funktioner kan vara begränsade',
    backOnline: 'Anslutningen är återställd',
    logoutSuccess: 'Du har loggats ut',

    // Common
    loading: 'Laddar...',
    error: 'Fel',
    success: 'Framgång',
    warning: 'Varning',
    info: 'Information',
    close: 'Stäng',
    cancel: 'Avbryt',
    save: 'Spara',
    edit: 'Redigera',
    delete: 'Ta bort',
    confirm: 'Bekräfta',
    yes: 'Ja',
    no: 'Nej'
  },

  en: {
    // Navigation
    services: 'Services',
    process: 'Process',
    about: 'About',
    contact: 'Contact',
    home: 'Home',

    // Hero section
    heroTitle: 'We solve your IT challenges, big and small',
    heroExperience: '+25 years experience',
    heroRate: 'Always 800 SEK/hour',
    heroSubtitle: 'Stop wasting time and money on ineffective IT solutions.',
    heroDescription: 'We handle everything from development and maintenance to technical consulting and IT support, so you can focus on what matters most to your business.',
    getStarted: 'Get Started',
    learnMore: 'Learn More',

    // Process section
    processTitle: 'How we work',
    processSubtitle: 'From strategy to delivery – we create technical solutions that drive your business forward.',

    processStep1Title: 'Kickoff Meeting',
    processStep1Desc: 'To understand your unique needs, we get to know your business in depth. From this, we create a needs analysis that provides a clear picture of which solutions best suit you.',

    processStep2Title: 'Planning',
    processStep2Desc: 'Based on your goals, we jointly create a clear project plan that you can easily follow. You have full control and approve the plan before we start work.',

    processStep3Title: 'Development',
    processStep3Desc: 'Work begins according to plan, and you are continuously updated. You get the opportunity to fine-tune work packages to ensure all results meet your goals.',

    processStep4Title: 'Delivery',
    processStep4Desc: 'Each work package is verified together with you to ensure all requirements are met. Packages are launched at a time that suits you, and we ensure everything works as it should.',

    // Process benefits
    processWhyChooseTitle: 'Why choose our process?',
    processWhyChooseSubtitle: 'Our structured approach ensures success in every project',
    processBenefit1Title: 'Clear communication',
    processBenefit1Desc: 'You are always informed about project progress',
    processBenefit2Title: 'Flexible adaptation',
    processBenefit2Desc: 'We adapt to your needs during the project',
    processBenefit3Title: 'Collaboration focus',
    processBenefit3Desc: 'We work as an extension of your team',

    // Services section
    servicesTitle: 'Regardless of industry or challenge, we can help you find an effective digital solution.',

    service1Title: 'System Development',
    service1Desc: 'We tailor solutions for your unique business needs. From new development (R&D) and prototype creation (PoC) to launching your first product version (MVP), we offer needs analysis, requirements, design, implementation and testing.',

    service2Title: 'Cloud Services',
    service2Desc: 'Optimize your IT platform with flexible and scalable solutions from AWS, Azure, Google Cloud and Digital Ocean. Get high availability, robust security and scalable hosting. We help you migrate, configure and optimize.',

    service3Title: 'System Integration and Third-party Services',
    service3Desc: 'We help you connect your internal systems and external services. Our solutions enable real-time data exchange, improved interoperability and automated processes.',

    service4Title: 'Strategic IT Consulting',
    service4Desc: 'Optimize your business strategy and costs with our strategic guidance. Get expert advice, develop IT strategies, identify IT needs and manage risks for maximum security and minimal disruptions.',

    // AI section
    aiTitle: 'Get started with AI and streamline your workflows',
    aiSubtitle: 'Maximize your productivity with AI that automates monotonous tasks, freeing up time and resources for what really counts – creative and strategic initiatives.',
    aiBenefit1: 'More time for strategic work',
    aiBenefit2: 'Less time on repetitive tasks',
    aiBenefit3: 'Reduce error margins',

    // Testimonials
    testimonialsTitle: 'What our customers say',

    // Team section
    teamTitle: 'Meet the team behind SireusCode',

    // Contact section
    contactTitle: 'Ready to take the next step?',
    contactSubtitle: 'Get in touch and we\'ll be happy to tell you more about how we can find IT solutions that drive your business forward.',
    contactDescription: 'At SireusCode, we are experts at turning ideas into reality. Fill out the form or contact us directly for a free consultation. We look forward to working with you!',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    email: 'Email',

    // Contact form
    contactFormTitle: 'Send us a message',
    name: 'Name',
    company: 'Company',
    message: 'Message',
    preferredContact: 'Preferred contact method',
    gdprConsent: 'I agree to have my data processed according to GDPR',
    sendMessage: 'Send Message',
    sending: 'Sending...',

    // Form validation
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email address',
    messageRequired: 'Message is required',
    gdprRequired: 'You must agree to the GDPR terms',

    // Notifications
    contactSuccess: 'Thank you! Your message has been sent.',
    contactError: 'An error occurred. Please try again later.',
    offlineMessage: 'You are offline - some features may be limited',
    backOnline: 'Connection restored',
    logoutSuccess: 'You have been logged out',

    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No'
  }
};

// Export individual language files for potential lazy loading
export { sv, en };